import ModalBody from './ModalBody'
import ModalText from './ModalText'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import ModalExplainer from './ModalExplainer'
import Modal from './Modal'

export * from './Modal'

export default Object.assign(Modal, {
  Body: ModalBody,
  Footer: ModalFooter,
  Header: ModalHeader,
  Text: ModalText,
  Explainer: ModalExplainer,
})
